<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13mDZb9/tc-custom/9781908117991.jpg?1704717799704" alt="This image is the cover for the book Winged Victory"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Winged Victory
      </h1>
      <p class="bookDescription body article font2">
        <b>Experience the chilling combat of World War I from inside an early biplane in this classic novel, by a pilot who lived through the war himself.</b><br/><br/> France, 1914. The war on the land is taking to the skies . . .<br/><br/> Pilot Tom Cundall is ready to take on the enemy in his trusty Camel fighter plane. But as he sees more and more planes shot down in flames, he begins to question the war, and what, or who, he is fighting for.<br/><br/> There is no bitter snarl nor self-pity in this classic novel about the air war of 1914-1918, based very largely on the author’s experiences.<br/><br/> Combat, loneliness, fatigue, fear, comradeship, women, excitement—they all are part of a brilliantly told story of war and courage by one of the most valiant pilots of the then Royal Flying Corps.<br/><br/><b>Praise for <i>Winged Victory</i></b><br/><br/><b>“The greatest novel of war in the air.” —<i>The Daily Mail </i>(UK)</b><br/><br/><b>‘Beautifully written with a poet’s eye as well as a pilot’s eye.” —<i>Evening Echo </i>(UK)</b><br/><br/><b>“Not only one of the best war books . . . but as a transcription of reality, faithful and sustained in its author’s purpose of re-creating the past life he knew, it is unique.” —Henry Williamson, author of <i>Tarka the Otter</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        V.M. Yeates
      </h2>
      
      <p class="authorDescription body article">Yeates was born at Dulwich, and educated at Colfe&#39;s School where according to Henry Williamson he used to read Keats under the desk during Maths, explored woods, fields and ponds and kept a tame tawny owl/ Yeates joined the Inns of Court Officer Training Corps in 1916 and transferred to the Royal Flying Corps (later the Royal Air Force) in May 1917. Serving with No. 46 Squadron, to which he was posted in February 1918, he flew 248 hours in Sopwith Camels, crashed four times, was shot down twice and scored five victories thereby achieving &quot;ace&quot; status. After the war, he died of tuberculosis in Fairlight Sanatorium at Hastings in 1934. He was survived by his wife Norah Phelps Yeates (n&eacute;e Richards) and his four children Mary, Joy Elinor (later married hristopher David Vowles), Guy Maslin (later married Binnie Yeates) and Rosalind (later married Edward Cullinan); all of whom had lived with Yeates in a small house in Kent on the Sidcup by-pass of the Dover Road.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grub Street
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2ebf9824